module.exports = __webpack_public_path__ + "img/product_thumbnail.38cbaaab.png";